module.exports = __webpack_public_path__ + "img/createSos.7ca7e55d.svg";